// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 768px){header{height:100px;padding:39px 20px 15px}}@media only screen and (max-width: 568px){header{height:100px;padding:30px 20px 7px;overflow:hidden}header .header-nav{font-size:12px;display:flex;flex-direction:row;justify-content:space-between}header .header-nav .btn-consultation{margin-right:0 !important;margin-left:0 !important}header .logo img{height:59px}}", ""]);
// Exports
module.exports = exports;
